import React from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiBriefcase, FiFileText, FiLogOut, FiGrid, FiUsers } from 'react-icons/fi';

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem('adminAuth');
        navigate('/admin/login');
    };

    const navItems = [
        { name: 'Dashboard', path: '/admin/dashboard', icon: FiGrid },
        { name: 'Manage Blogs', path: '/admin/blogs', icon: FiFileText },
        { name: 'Manage Careers', path: '/admin/careers', icon: FiBriefcase },
        { name: 'Applications', path: '/admin/applications', icon: FiUsers },
    ];

    const isActive = (path) => location.pathname === path;

    return (
        <div className="flex min-h-screen bg-gray-100 font-sans">
            {/* Sidebar */}
            <aside className="w-64 bg-white shadow-xl hidden md:flex flex-col">
                <div className="p-6 border-b border-gray-100 flex items-center justify-center">
                    <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
                        Admin<span className="text-primary-500">Panel</span>
                    </h2>
                </div>

                <nav className="flex-1 p-4 space-y-2 overflow-y-auto">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${isActive(item.path)
                                ? 'bg-primary-50 text-primary-600 shadow-sm'
                                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                }`}
                        >
                            <item.icon className={`text-xl ${isActive(item.path) ? 'text-primary-500' : 'text-gray-400 group-hover:text-gray-600'}`} />
                            <span className="font-medium">{item.name}</span>
                        </Link>
                    ))}
                </nav>

                <div className="p-4 border-t border-gray-100">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 w-full px-4 py-3 text-red-500 hover:bg-red-50 rounded-xl transition-colors font-medium"
                    >
                        <FiLogOut className="text-xl" />
                        <span>Logout</span>
                    </button>
                    <Link to="/" className="flex items-center gap-3 w-full px-4 py-3 mt-1 text-gray-500 hover:bg-gray-50 rounded-xl transition-colors text-sm">
                        <FiHome className="text-xl" />
                        <span>Back to Website</span>
                    </Link>
                </div>
            </aside>

            {/* Mobile Header (Visible only on small screens) */}
            <div className="md:hidden fixed top-0 w-full bg-white z-50 shadow-md p-4 flex justify-between items-center">
                <h2 className="text-xl font-bold text-gray-800">AdminPanel</h2>
                <button onClick={handleLogout} className="text-red-500"><FiLogOut size={24} /></button>
            </div>

            {/* Main Content */}
            <main className="flex-1 p-4 md:p-8 mt-16 md:mt-0 overflow-y-auto h-screen">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
